module.exports = __webpack_public_path__ + "static/media/gtp-missions-icon-text.8cc25472.png";